import React from 'react';
import { Link } from 'react-router-dom';

// Compact video row — thumbnail, title, creator, duration. Shared by the feed's
// Today's Picks sidebar and Explore's discovery section so a video looks the
// same wherever it is listed.
//
// A missing thumbnail renders the plate empty rather than a broken image icon;
// alt is the title, which is the accessible name a screen reader needs since
// the surrounding text is also inside the link.
const VideoListItem = ({ video }) => (
  <Link to={`/video/${video.id}`} className="flex gap-3 cursor-pointer group">
    <div
      className="w-24 h-[54px] rounded-lg overflow-hidden flex-shrink-0"
      style={{ backgroundColor: 'var(--pill-bg)' }}
    >
      {video.thumbnail && (
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
      )}
    </div>
    <div className="flex-1 min-w-0">
      <p className="text-xs font-semibold line-clamp-2 leading-snug text-primary group-hover:text-brand-accent transition-colors">
        {video.title}
      </p>
      {video.creator && <p className="text-xs text-tertiary mt-0.5 truncate">{video.creator}</p>}
      {/* views is null for every real source — only mock rows carry it — so in
          practice this line is the duration alone. Kept tolerant anyway. */}
      {[video.duration, video.views != null ? `${video.views} views` : null].filter(Boolean).length > 0 && (
        <p className="text-xs text-tertiary">
          {[video.duration, video.views != null ? `${video.views} views` : null].filter(Boolean).join(' · ')}
        </p>
      )}
    </div>
  </Link>
);

export default VideoListItem;
